
/* eslint no-underscore-dangle: [1, { "allow": [] }] */
import React from 'react';
import PropTypes from 'prop-types';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Block from './components/Block';
import Map from './components/Map/index';
import {Button, buttonTypes} from '../../components/Button';
import SearchBox from '../../components/Map/SearchBox';
import './Cart.scss';
import routerConfig from "../../config/router";
import {round} from "../../utils/func";

class Cart extends React.Component {

  state = {
    zoom: 10,
    lat: 0,
    lng: 0,
    radius: 0,
    hotels: [],
    meetingPlace: null,
    error: {},
    toursPrices: {}
  };

  static propTypes = {
    history: PropTypes.object,
    getCartTours: PropTypes.func,
    toursList: PropTypes.array,
    getTourById: PropTypes.func,
    deleteFromCart: PropTypes.func,
    listInCart: PropTypes.array,
    changeTourData: PropTypes.func,
    cities: PropTypes.array,
    setMetingPlace: PropTypes.func,
  };

  componentWillMount() {
    // if(!this.props.toursList)
    this.props.getCartTours();
    this.setMapParams(this.props.cities, this.props.toursList)
  }

  componentWillReceiveProps(next) {
    this.setMapParams(next.cities, next.toursList)

  }


  /* getMarkers = (map, lat, lng, radius) => {
    if (map && lat && lng && radius) {
      const service = new google.maps.places.PlacesService(map.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);
      service.nearbySearch({
        location: {lat, lng},
        radius,
        type: ['lodging']
      }, (res, status) => {
        if (status === 'OK' && res && res.length) {
          this.setState({hotels: this.createMarkersArr(res)})
        }
      });
    }
  }; */

  onZoomChange = (/* m, center, zoom */) => {
    // this.getMarkers(m.context, center.lat(), center.lng(), this.state.radius * 1000 / zoom)
  };

  getPlaces = (/* m */) => {
    const {
      lat,
      lng,
      radius,
      hotels
    } = this.state;
    if (hotels.length === 0 && radius && lat && lng) {
      // this.getMarkers(m.context, lat, lng, radius * 1000);
    }
  };

  /* createMarkersArr = (arr) => {
    const result = [];
    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        // console.log(arr[i])
        if (arr[i] && arr[i].geometry && arr[i].geometry.location) {
          result.push({
            countId: i,
            lat: arr[i].geometry.location.lat(),
            lng: arr[i].geometry.location.lng(),
            icon: '/assets/img/ic_hotel.svg',
            name: arr[i].name,
            address: arr[i].vicinity
          })
        }
      }
    }
    return result;
  }; */

  setMapParams = (cities, tourList) => {
    if (cities && cities.length && tourList && tourList.length && tourList[0]) {
      const {cityId} = tourList[0];
      for (let i = 0; i < cities.length; i++) {
        if (cities[i].id === cityId) {
          const {lat, lng, vehicle} = cities[i];
          if (lat && lng && vehicle && vehicle.radius) {
            this.setState({lat, lng, radius: vehicle.radius, zoom: this.createMapZoom(vehicle.radius)});
          }
          break;
        }
      }
    }
  };

  createMapZoom(radius) {
    const defaultZoom = 10;
    if (radius <= 5)
      return defaultZoom + 3;
    if (radius > 5 && radius <= 10)
      return defaultZoom + 2;
    if (radius > 10 && radius <= 16)
      return defaultZoom + 1;
    if (radius > 16 && radius <= 20)
      return defaultZoom;
    return defaultZoom;
  }

  arePointsNear = (checkPoint, centerPoint, km) => {
    const ky = 40000 / 360;
    const kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
    const dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
    const dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
    return Math.sqrt(dx * dx + dy * dy) <= km;
  };

  setMeetingAddress = (address) => {
    if (address.address && address.lat && address.lng) {

      if (this.arePointsNear(
          {lat: address.lat, lng: address.lng},
          {lat: this.state.lat, lng: this.state.lng},
          this.state.radius)
      ) {
        this.props.setMetingPlace(address);
        this.setState({
          meetingPlace: {...address},
          error: {...this.state.error, address: ''}
        })
      } else {
        this.setState({error: {address: 'Address outside the radius'}})
      }
    }
  };

  book = () => {
    const {
      meetingPlace,
    } = this.state;

    const {
      listInCart
    } = this.props;
    if (!listInCart || listInCart.length === 0) {
      this.setState({error: {book: 'Please Add Tour'}});
      NotificationManager.error('Please Add Tour', '', (3* 1000));
    } else if (!meetingPlace) {
      this.setState({error: {book: 'Please Select Meeting Place'}});
      NotificationManager.error('Please Select Meeting Place', '', (3* 1000));
    } else {
      this.props.history.push(routerConfig.booking)
    }
  };

  setTourBlockPrices = (pr) => {
    this.setState({toursPrices: Object.assign(this.state.toursPrices, pr)});
  };

  calculateTotalPrice() {
    const {toursPrices} = this.state;
    const tPKeys = Object.keys(toursPrices);
    let result = 0;
    for (let i = 0; i < tPKeys.length; i++) {
      result += toursPrices[tPKeys[i]].total
    }
    return round(result)
  }

  showLastError = () => {
    const {error} = this.state;
    const objKeys = Object.keys(error);
    for (let i = 0; i < objKeys.length; i++) {
      if (error[objKeys[i]]) {
        return (
          <p className="error-block__tour">
            <i className="fa fa-exclamation" aria-hidden="true" />
            Error: <span>{error[objKeys[i]]}</span>
          </p>
        )
      }
    }
    return ''
  };

  deleteFromCart = (data) => {
    const {deleteFromCart} = this.props;
    const toursPrices = {...this.state.toursPrices};
    delete toursPrices[data];
    this.setState({toursPrices});
    deleteFromCart(data);
  };

  render() {

    const {
      toursList,
      listInCart,
      changeTourData,
      cities,
    } = this.props;

    const {
      lat,
      lng,
      radius,
      hotels,
      meetingPlace,
      error,
      zoom,
    } = this.state;

    if (toursList && toursList.length > 0)
      return (
        <div className="cart">
          <h2 className="cart__title">Cart</h2>
          <div className="cart__list">
            {
              toursList.map((tour) => {
                for (let i = 0; i < listInCart.length; i++) {
                  if (tour.id === listInCart[i].id) {
                    return (
                      <Block
                        key={`home-tour-${tour.id}`}
                        {...tour}
                        selectedData={listInCart[i]}
                        deleteFromCart={this.deleteFromCart}
                        changeTourData={changeTourData}
                        cities={cities}
                        onPrices={this.setTourBlockPrices}
                      />
                    )
                  }
                }
                return null;
              })
            }
          </div>
          <div className="cart__map">
            <div className="cart__map-item cart__map-block">
              <Map
                center={{lat, lng}}
                zoom={zoom}
                height={400}
                radius={radius}
                mapReady={this.getPlaces}
                markers={hotels}
                onCircleAddress={this.setMeetingAddress}
                onZoomChange={this.onZoomChange}
                onDragMap={this.onZoomChange}
                markerAddress={meetingPlace}
              />
            </div>
            <div className="cart__map-item">
              <div className="cart__map-title-wrap">
                <span className="ti-location-pin" />
                <p className="cart__map-title">Choose your pick up point in this radius</p>
              </div>
              <div className="cart__map-search">
                <SearchBox
                  onNewPlace={this.setMeetingAddress}
                  address={meetingPlace}
                />
                {error.address && <span className="error-block">{error.address}</span>}
              </div>
              <div className="cart__map-footer">
                {meetingPlace && meetingPlace.address &&
                <div className="cart__map-text">
                  <p
                    className="cart__map-label">Your pick up point is confirmed at:
                  </p>
                  {meetingPlace.address}
                </div>
                }
              </div>
              <div className="cart__map-title-wrap">
                <span className="ti-location-pin" />
                <p className="cart__map-title">Transportation included in tour price</p>
              </div>
              {error.book && <span className="error-block">{error.book}</span>}
            </div>

          </div>

          <div className="cart__book">
            <p className="cart__book-price">
              <span className="cart__book-label">Total Price </span>
              <span className="cart__book-content">$ {this.calculateTotalPrice()}</span>
            </p>
            <div className="create-tour__error">
              {
                this.showLastError()
              }
            </div>
            <Button
              type={buttonTypes.AUTHENTICATION}
              name="Book"
              onClick={this.book}
            />
          </div>
          <NotificationContainer />
        </div>
      );
    return (

      <div className="cart__placeholder">
        <h2 className="cart__placeholder-title">Cart</h2>
        <div className="cart__placeholder-content">
          <p className="cart__placeholder-text">Your cart is empty now</p>
          <p className="cart__points">...</p>
          <img
            className="cart__placeholder-img"
            src="/assets/img/cart_placeholder.png"
            alt="placeholder"
          />
        </div>
      </div>
    )
  }
}

export default Cart;




// WEBPACK FOOTER //
// ./src/app/containers/Cart/Component.js